import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  Organization: {
    keyFields: ['code'],
    fields: {
      owners: {
        merge(_, incoming) {
          return incoming;
        }
      }
    }
  },
  Query: {
    fields: {
      organization: {
        merge(_, incoming) {
          return incoming;
        }
      },
      personAccessRightRequests: {
        keyArgs: ['accountCode', 'status', 'immutableId', 'infoPerson'],
        read(a) {
          return a;
        },
        merge(existing = { edges: [] }, incoming, w) {
          if (w.variables?.page.offset === 0) {
            return incoming;
          }

          return {
            ...incoming,
            edges: [...existing.edges, ...incoming.edges]
          };
        }
      },
      directoriesAuthenticatingPerson: {
        merge(_, incoming) {
          return incoming;
        }
      }
    }
  }
};
